// Shown in two places: the note under the last card at the handling-unit cap,
// and the tooltip on a card's error when the shipment goes over it. Kept here
// so the two can't drift apart.
export function lineItemsHandlingUnitsLimitExplanation(
  maxHandlingUnits: number,
): string {
  return `Individual shipments cannot contain more than ${maxHandlingUnits} handling units in total. Smaller items should be combined onto pallets for proper freight shipping. Please contact our team if you have any questions about this.`;
}
